import React, {createContext, useContext, useEffect, useRef, useState} from 'react';

const SessionConfigurationContext = createContext();

export const SessionConfigurationProvider = ({children}) => {
    const [isDesktopView, setIsDesktopView] = useState(window.innerWidth > 1230);
    const [isWideBottom, setIsWideBottom] = useState(window.innerWidth > 650);
    const [isTouch, setIsTouch] = useState(false);
    const isTouchRef = useRef(false);
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsDesktopView(width > 1230);
            setIsWideBottom(width > 650);
            setInnerWidth(width);
        };

        const touchCheck = ('ontouchstart' in window || navigator.maxTouchPoints > 0);
        setIsTouch(touchCheck);
        isTouchRef.current = touchCheck;

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function monitorPaymentWindow(paymentWindow) {
        const paymentWindowCheckInterval = setInterval(() => {
            if (paymentWindow.closed) {
                clearInterval(paymentWindowCheckInterval);
                handlePaymentCompletion(false);
            } else {
                try {
                    const href = paymentWindow.location.href;
                    if (href.indexOf(window.location.origin) === 0) {
                        if (href.indexOf('/close-the-window') !== -1) {
                            paymentWindow.close();
                            clearInterval(paymentWindowCheckInterval);
                            handlePaymentCompletion(true);
                        }
                    }
                } catch (e) {
                    // Ignore cross-origin errors
                }
            }
        }, 500);
    }

    function handlePaymentCompletion(success) {
        if (success) {
            alert('Payment was successful!');
        } else {
            alert('Payment window was closed before completion.');
        }
    }

    return (
        <SessionConfigurationContext.Provider
            value={{
                isDesktopView,
                isWideBottom,
                monitorPaymentWindow,
                isTouch,
                innerWidth,
            }}>
            {children}
        </SessionConfigurationContext.Provider>
    );
};

export const useSessionConfiguration = () => useContext(SessionConfigurationContext);
